module.exports = __webpack_public_path__ + "static/media/np_1.3eef837e.jpg";